<div class="toolbar" role="banner">
  <div class="logo-container">
    <img class="logo" alt="Meals 2Go" src="../../../../assets/images/HeaderImage.png" />
  </div>
  <div class="authentication-container">
    @if (!loginDisplay) {
      <button mat-raised-button (click)="loginRedirect()">Login</button>
    }
  </div>
  <div class="button-container">
    @if (authManager.doesCurrentAccountHaveAnyRole(["IT", "Admin", "Division"])) {
      <button mat-button (click)="openSetupNewStoreDialog()">Set Up New Store</button>
    }
  </div>
  <facility-selection></facility-selection>
</div>

<div class="main-content">
  <div class="sidebar" role="navigation">
    <app-sidebar-navigation></app-sidebar-navigation>
  </div>
  <div class="content" role="main">
    @if (!loginDisplay) {
      <div>
        Please log in to Meals2Go Administration: <button mat-raised-button (click)="loginRedirect()">Login</button>
      </div>
    }
    @if (loginDisplay && !isFacilitySelected) {
      <div>Please select a facility from the dropdown menu in the upper right!</div>
    }

    <router-outlet></router-outlet>
  </div>
</div>

@if (statusService.isLoading || statusService.forceLoader) {
  <div class="spinner-modal">
    <div class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
      <div class="progress-container">
        <h3>Request In-Progress</h3>
        @if (statusService.isSaving) {
          <div class="progress-indicator">
            <mat-progress-bar mode="determinate" [value]="statusService.completionCountPercentage"></mat-progress-bar>
            <div>{{ statusService.completionCount }}/{{ statusService.numberOfRequests }}</div>
          </div>
        }
      </div>
    </div>
  </div>
}
